var _path, _path2, _path3, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Xls502(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a5d6a7",
    d: "M32.8,9H16.2c-1.7,0-3.1,1.4-3.1,3.1V44c0,1.7,1.4,3.1,3.1,3.1h23.7c1.7,0,3.1-1.4,3.1-3.1V19.1 c0-0.5-0.2-1-0.6-1.4l-8.1-8.1C33.9,9.2,33.4,9,32.8,9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M38.5,27.9V14.5h-7c-1.1,0-2-0.9-2-2v-7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M22.8,5.5H12.5c-1.7,0-3,1.3-3,3v31c0,1.7,1.3,3,3,3h23c1.7,0,3-1.3,3-3v-5.3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.5,
    x2: 29.5,
    y1: 14.5,
    y2: 5.5,
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28.8,
    x2: 19.3,
    y1: 34.8,
    y2: 25.3,
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 19.3,
    x2: 28.8,
    y1: 34.8,
    y2: 25.3,
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Xls502);
export default __webpack_public_path__ + "static/media/icons8-xls-50-2.43b1c6bdebdb6dcfb04b71bac6bfbf22.svg";
export { ForwardRef as ReactComponent };